import { View } from "binder"
import { DistrictSelector } from "../../districts/districtManipulation/districtSelector";
import { CashBoxEditorViewModel } from "./cashBoxEditor-viewModel"

export class CashBoxEditorView extends View<CashBoxEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-697704DD-3BD1-4BC1-AE25-52BA2161B2E7"
    }
    loadHtml(): string {
        let element = require('./cashBoxEditor.html').default;
        let style = require('./cashBoxEditor.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set districtSelector(v: DistrictSelector) { this._districtSelector = v; } public get districtSelector(): DistrictSelector { return this._districtSelector;} private _districtSelector: DistrictSelector;
    public set disabled(v: boolean) { this._disabled = v; } public get disabled(): boolean { return this._disabled;} private _disabled: boolean;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;

    back(){
        this.dataContext.back();
    }

    save(){
        this.dataContext.save();
    }
}
